import { useMemo } from 'react';

import useUrlSearchParams from 'hooks/useUrlSearchParams';
import { getConditionalObject } from 'utils/data';

import { EDITOR_QUERY_PARAM, EDITOR_VALUES } from '../useEditorOverride/constants';

const useEditorLocationDescriptor = () => {
  const searchParams = useUrlSearchParams();
  const editorParam = searchParams[EDITOR_QUERY_PARAM];

  return useMemo(
    () =>
      getConditionalObject(EDITOR_VALUES.includes(editorParam), () => ({
        search: `?${EDITOR_QUERY_PARAM}=${encodeURIComponent(editorParam)}`,
      })),
    [editorParam],
  );
};

export default useEditorLocationDescriptor;
